export default "__VITE_ASSET__BAUlwTsH__"